module.exports = __webpack_public_path__ + "static/img/アセット 3@2x.500acb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 3@2x.png
// module id = LJNv
// module chunks = 1